import React from 'react';
import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import TSButton from 'components/common/Button/Button';

const CheckIns = ({
  checkins,
  colourScheme = 'display',
  dialog = false,
  handleClose = () => {},
}) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  return (
    <div
      className={`checkins ${dialog ? `max-w-7xl mx-auto p-4 h-svh flex flex-col justify-center content-center` : `w-full`}`}
    >
      {dialog && (
        <div className="header mb-4 grid grid-cols-3 gap-4">
          <div id="logo" className="logo col-span-1">
            {/* <img src={TrailSafeLogo} alt="TrailSafe Logo" className="w-32" /> */}
          </div>
          <div id="title" className="title col-span-1">
            <h1 className="text-3xl font-bold text-center">Checkins</h1>
          </div>
          <div id="close-btn" className="close-btn col-span-1 flex justify-end">
            <TSButton
              btnText=""
              classList="py-4"
              startIcon={true}
              iconName="Exit"
              iconWidth={24}
              iconHeight={24}
              onClickFunc={() => handleClose()}
            />
            {/* <button className="text-gray-500 hover:text-gray-700" onClick={handleClose}>
            <CloseIcon fontSize="large" />
          </button> */}
          </div>
        </div>
      )}
      <div className="max-w-[500px]">
        <div
          className={`w-full 
            ${
              colourScheme === 'display'
                ? 'bg-[var(--ts-primary)] text-[var(--ts-text-primary)]'
                : 'bg-[var(--ts-accent-light)] text-[var(--ts-text-dark)] border-4 border-solid border-[var(--ts-primary-light)]'
            }
             ' rounded-2xl p-4 gap-2 flex flex-col
             overflow-y-auto ${dialog ? '' : 'max-h-[200px]'}`}
        >
          {checkins
            .sort((a, b) => new Date(a.CheckinTime) - new Date(b.CheckinTime))
            .map((checkin, index) => (
              <div key={index} className="checkin-entry">
                {index !== 0 && (
                  <div className="divider mb-2 border-t border-gray-300" />
                )}
                <Typography variant="h6" className="mb-2">
                  {checkin.CheckinLocation} -{' '}
                  {dayjs
                    .utc(checkin.CheckinTime)
                    .local()
                    .format('D MMM h:mm A')}
                </Typography>
                <Typography variant="body1" className="mb-4">
                  Route: {checkin.TrailOptionName}
                </Typography>
              </div>
            ))}

          {/* <MLTextField
            label="Relationship"
            defaultVal={checkIns.Relationship}
            isDisabled={true}
            variant="standard"
            textColourOverride={
              colourScheme === 'display'
                ? 'var(--ts-text-primary)'
                : 'var(--ts-text-dark)'
            }
          /> */}
        </div>
      </div>
    </div>
  );
};

export default CheckIns;
